/* unplugin-vue-components disabled */import script from "./noticeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./noticeDialog.vue?vue&type=script&setup=true&lang=ts"

import "./noticeDialog.vue?vue&type=style&index=0&id=01875d99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01875d99"]])

export default __exports__